import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4bcac8ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "users-nav-bar pb-3 flex relative" }
const _hoisted_2 = { class: "flex gap-3 items-center absolute" }
const _hoisted_3 = { style: {"min-width":"135px"} }
const _hoisted_4 = {
  key: 0,
  class: "gordita-400-12 brand_almost_black"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-user-plus text-[22px] !mr-2" }, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Add User ")

import { IncrediButton, useIncrediDialog } from 'incredi-ui';
import IncrediTransition from '@/components/incredi-transition/incredi-transition.vue';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { ref, computed, onUnmounted, inject } from 'vue';
import elementIds from '@/const/elementIds.json';
import { IKRightDrawer } from '@/views/Layout/RightDrawer.InjectionKeys';
import COLORS from '@/design-system/colors.json';
import UsersActivityFilter from '@/views/users/components/usersActivityFilter.vue';
import addNewUserDialog from './addNewUserDialog.vue';
import { useUsersPage } from '../users.helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'users-nav-bar',
  setup(__props) {

const usersPage = useUsersPage();
const rightDrawer = inject(IKRightDrawer);

const dialog = useIncrediDialog();
const searchQuery = usersPage?.usersTable.filters.search;
const expandSearchBar = ref(false);
onUnmounted(() => {
  dialog?.close(addNewUserDialog.name);
});
const isSearchInputEllipsis = ref(false);
const searchInput = ref();

const checkSearchInputEllipsis = computed(() => searchInput.value?.offsetWidth < searchInput.value?.scrollWidth);
const handleExpand = (e: boolean) => {
  expandSearchBar.value = e;
};
const SearchLabel = computed(() => (expandSearchBar.value ? 'Search by any field' : ''));

const closeDialog = () => {
  dialog?.close(addNewUserDialog.name);
};

return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(UsersActivityFilter),
          _createVNode(IncrediTransition, {
            class: "search-nav",
            style: _normalizeStyle({
            transition: 'max-width 0.2s,background 0.2s',
            maxWidth: !_unref(searchQuery)?.get.value && !expandSearchBar.value ? '86px' : '200px',
            width: expandSearchBar.value ? '200px' : '86px', //this gets to the figma's length when closed with search input.
            background: _unref(searchQuery)?.get.value && !expandSearchBar.value ? _unref(COLORS)['Hovers/hover_primary'] : null,
          }),
            onTransitionend: _cache[4] || (_cache[4] = ($event: any) => (isSearchInputEllipsis.value = _unref(checkSearchInputEllipsis)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_input, {
                ref_key: "searchInput",
                ref: searchInput,
                "data-testid": "users-search-input",
                placeholder: _unref(SearchLabel),
                "model-value": _unref(searchQuery)?.get.value,
                "input-style": { color: _unref(COLORS)['Text/Dark'] },
                borderless: "",
                dense: "",
                debounce: "300",
                class: _normalizeClass(["search", { expandSearch: expandSearchBar.value }]),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = 
              $event => {
                _unref(usersPage)?.usersTable.selectedUser.clear();
                _unref(rightDrawer)?.close();
                _unref(searchQuery)?.set($event as string);
              }
            ),
                onFocus: _cache[2] || (_cache[2] = ($event: any) => (handleExpand(true))),
                onBlur: _cache[3] || (_cache[3] = ($event: any) => (handleExpand(false)))
              }, {
                append: _withCtx(() => [
                  _withDirectives(_createVNode(_component_q_icon, {
                    "data-testid": "clear-search-input",
                    name: "icon-x-small",
                    class: "cursor-pointer search-clear-icon",
                    onClick: _cache[0] || (_cache[0] = 
                  () => {
                    _unref(searchQuery)?.set('');
                  }
                )
                  }, null, 512), [
                    [_vShow, _unref(searchQuery)?.get.value && expandSearchBar.value]
                  ])
                ]),
                prepend: _withCtx(() => [
                  _createVNode(_component_q_icon, { class: "uil uil-search search-icon" }),
                  (!expandSearchBar.value && !_unref(searchQuery)?.get.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Search "))
                    : _createCommentVNode("", true)
                ]),
                default: _withCtx(() => [
                  (!expandSearchBar.value && isSearchInputEllipsis.value)
                    ? (_openBlock(), _createBlock(_component_q_tooltip, {
                        key: 0,
                        offset: [0, 18],
                        anchor: "bottom right",
                        self: "center right",
                        "content-class": "tooltip-background"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(searchQuery)?.get.value), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["placeholder", "model-value", "input-style", "class"])
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _createVNode(_unref(IncrediButton), {
          "data-testid": _unref(elementIds).users.create.buttons.openDialogButton,
          class: "flex items-center rounded-[2px] ml-auto",
          size: "small",
          onClick: _cache[5] || (_cache[5] = ($event: any) => {
          _unref(usersPage)?.usersTable.selectedUser.clear();
          _unref(rightDrawer)?.close();
          _unref(dialog)?.open('addNewUserDialog', addNewUserDialog, {});
        }),
          onCloseDialog: closeDialog
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _hoisted_6
          ]),
          _: 1
        }, 8, ["data-testid"])
      ])
    ]),
    _: 1
  }))
}
}

})